import(/* webpackMode: "eager" */ "/home/runner/work/portal/portal/frontend/web/src/app/global-error.js");
